import { render, staticRenderFns } from "./ReportTableDowntimeByShift.vue?vue&type=template&id=63979104&"
import script from "./ReportTableDowntimeByShift.vue?vue&type=script&lang=js&"
export * from "./ReportTableDowntimeByShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports